var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegalAgreements',{attrs:{"get-url":"/space/get-purchase-cancellation-policy","title":_vm.$t('labels.purchaseCancellationPolicy')}})}
var staticRenderFns = []

export { render, staticRenderFns }